import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getvendorsPOList,
  downloadProjectPO,
  getProject,
} from "../../../actions/project-management.action";
import { warningSnackBar } from "../../../actions/common.action";
import PayInvoice from "../../vendor-payment/pay-invoice";
import { CONTRACTORS, PROJECT_MANAGEMENT, VENDOR_PAYMENT } from "../../../constants/route-paths";
import { format } from "date-fns";
import DateFilter from "../../../components/date-filter-dialog"
import { numberFormat } from "../../../util/currency-formatter";
import DownloadDialog from "../../../components/download-dialog";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { withRouter } from "../../../util/with-router";
import { getGlobalSettingTemplateTypes } from "../../../actions/global-setting-template.action";
import '../../projects/scss/task.scss'
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Popover from 'react-bootstrap/Popover';
import idx from "idx";
import { resolveProjectType } from "../../projects/utils/resolve-project-type";
import CustomTable from '../../../components/table/table';
import Tooltip from '@mui/material/Tooltip';
import { Autorenew } from "@mui/icons-material";

function SupplierInvoiceList({ projectModule, writePermission, ...props }) {

  const [state, setState] = useState({
    showPayInvoice: false,
    columns: [],
    list: [],
    submitDialog: false,
    discardDialog: false,
    supplierCount: null,
    subContractorCount: null,
    vendorType: "ALL",
    invoiceData: {},
    workType: "project",
    projectId: null,
    suppliers: [],
    templateOptions: [],
    subContractors: [],
    subContractorsTable: [],
    allInvoices: [],
    breadCumbText: null,
    showFilter: false,
    downloadData: {
      open: false,
      id: "",
      template: "",
    },
    projectData: null
  })

  useEffect(() => {
    init()
  }, [])

  const init = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const projectId = urlParams.get("project");
    const poId = urlParams.get("poId") || urlParams.get("woId");

    let breadCumbText = null;
    if (projectId) {
      breadCumbText = "Project";
    }

    setState(prev => ({
      ...prev,
      projectId, poId, breadCumbText
    }));
    fetchList()

    if (!state.projectData && projectId) {
      props.getProject(projectId, { type: "projectBreadcrumb" }).then((projectData) => {
        setState(prev => ({
          ...prev,
          projectData: projectData
        }));
      })
    }
  }

  const handleMenu = (rowData) => {
    setState(prev => ({
      ...prev,
      invoiceId: rowData.invoiceId,
      invoiceData: {
        poNo: rowData.poNumber,
        poId: rowData.poId,
        isSubContractor: rowData.vendorType === "sub-contractor",
        invoiceId: rowData.invoiceId,
        projectId: rowData.projectId || state.projectId,
        vendorId: rowData.vendorId,
      },
    }));
  };

  const handlePayInvoiceModal = (status, allProjects = false) => {
    if (!status) {
      fetchList();
    }
    setState(prev => ({
      ...prev,
      showPayInvoice: status,
      invoiceData: { ...(allProjects ? {} : { ...prev.invoiceData }) },
    }));
  };

  const fetchList = async ({ pageNo, pageSize, vendorType, startDate, endDate, } = {}) => {
    const params = {
      pageNo,
      pageSize,
      vendorType: 'sub-contractor',
      startDate,
      endDate,
    };
    let { projectId, poId } = state;
    if (projectId) {
      params.projectId = projectId;
    }
    if (poId) {
      params.poId = poId;
    }
    setState(prev => ({
      ...prev,
      vendorType: vendorType || "ALL",
    }));

    let { list, vendorTypesCount } = await props.getvendorsPOList(params);

    const suppliers = (Array.isArray(list) && list.filter(({ vendorType }) => vendorType === "Supplier")) || [];
    const subContractors = (Array.isArray(list) && list.filter(({ vendorType }) => vendorType === "sub-contractor")) || [];
    const allInvoices = (Array.isArray(list) && list) || [];
    const supplierCount = vendorTypesCount.suppliersCount || 0;
    const subContractorCount = vendorTypesCount.subContractorsCount || 0;
    const columns = [
      { title: "Vendor Name", field: "vendorName", render: (rowData) => rowData.vendorName },
      // {
      //   title: "Vendor Type",
      //   field: "vendorType",
      //   // lookup: { "sub-contractor": "Sub-Contractor", Supplier: "Supplier" },
      //   render: (rowData) => rowData.vendorType == 'sub-contractor' ? "Sub-Contractor" : rowData.vendorType
      // },
      {
        title: "Invoice No",
        field: "invoiceNo",
        render: (rowData) => (
          <span>{rowData.invoiceNo}</span>
        ),
      },
      {
        title: "WO Number",
        field: "poNumber",
        /* fId is the WO number with project prefix and Suffix if null then default to wo Number*/
        render: (rowData) => rowData.fId || rowData.poNumber
      },
      { title: "Project/Job", field: "projectName", render: (rowData) => rowData.projectName },
      {
        title: "Invoice Date",
        field: "invoiceDate",
        render: (rowData) => (rowData.invoiceDate && format(new Date(rowData.invoiceDate), "dd/MM/yyyy")) || "",
      },
      {
        title: "Due Date",
        field: "dueDate",
        render: (rowData) => rowData.dueDate ? format(new Date(rowData.dueDate), "dd/MM/yyyy") : "",
      },
      {
        title: "Amount Paid",
        field: "amountPaid",
        render: (rowData) => `${numberFormat(rowData.amountPaid)}`,
        class: 'text-right',
      },
      {
        title: "Retained Amount",
        field: "retainedAmount",
        render: (rowData) => `${numberFormat(rowData.retainedAmount)}`,
        class: 'text-right',
      },
      {
        title: "Received By",
        field: "userName",
        render: (rowData) => rowData.userName
      },
    ];
    list.forEach((item, index) => {
      item["id"] = index;
      return item;
    });
    setState(prev => ({
      ...prev,
      supplierCount,
      subContractorCount,
      columns,
      list,
      suppliers,
      subContractors,
      subContractorsTable: structuredClone(subContractors),
      allInvoices,
    }));
  };

  const viewPO = () => {
    const { workType, invoiceId, projectId, poId } = state;
    props.history(
      `/${CONTRACTORS}/${VENDOR_PAYMENT}/view/${invoiceId}${`?type=${workType}`}${projectId ? `&id=${projectId}` : ""}${poId ? `&poId=${poId}` : ""}`
    );
  };

  const showFilterHandler = () => {
    setState(prev => ({
      ...prev,
      showFilter: !prev.showFilter,
    }));
  };

  const convertDateFormat = (dateString) => {
    let date = Date.parse(dateString);
    date = new Date(date)
    return date
  }

  const resetInvoiceData = () => {
    fetchList()
  }

  const dateChangeFilter = (startDate, endDate) => {
    if (startDate || endDate) {
      const table = [...state.subContractors]
      const filter = table.filter(({ invoiceDate }) => {
        const newDate = convertDateFormat(invoiceDate)
        return newDate && (new Date(startDate) <= newDate && newDate <= new Date(endDate))
      })
      setState(prev => ({
        ...prev,
        subContractorsTable: filter,
        startDate,
        endDate
      }))
    }
    else {
      setState(prev => ({
        ...prev,
        subContractorsTable: prev.subContractors,
        startDate,
        endDate
      }))
    }
    showFilterHandler()
  };

  const gettemplate = async (type) => {
    let newdata = [];
    let projectId = state.projectId;
    const templateData = await props.getGlobalSettingTemplateTypes(type, projectId);
    if (Array.isArray(templateData)) {
      templateData.forEach((item) => {
        newdata.push({
          value: item.id,
          key: item.name,
        });
      });
    }
    setState(prev => ({
      ...prev,
      templateOptions: newdata
    }));
  };

  const handleDownloadDialog = (id = "", templateType = "subcontractor_payment_schedule", overrideData = null) => {
    const currentId = id && (typeof id === 'string' || typeof id === 'number') ? id : state.invoiceId;
    setState(prev => {
      const isOpening = !prev.downloadData.open;
      const newState = {
        ...prev,
        downloadData: {
          ...prev.downloadData,
          open: isOpening,
          id: currentId,
          overrideData
        }
      };
      return newState;
    });

    if (!state.downloadData.open) {
      gettemplate("subcontractor_payment_schedule", currentId);
    }
  };

  const downloadFile = async (fileFormat = "pdf", templatevalue) => {
    try {
      const { downloadData = {} } = state;
      if (fileFormat === "pdf" || fileFormat === "ALL") {
        await props.downloadProjectPO(downloadData.id, fileFormat, templatevalue, undefined, downloadData.overrideData).catch(e => console.error(e));
      }
      if (fileFormat === "docx" || fileFormat === "ALL") {
        await props.downloadProjectPO(downloadData.id, fileFormat, templatevalue, undefined, downloadData.overrideData).catch(e => console.error(e));
      }
      handleDownloadDialog();
    } catch (e) {
      console.error(e)
    }
  };


  const ViewProjectList = () => {
    let resolvedType = resolveProjectType(idx(state, (_) => _.projectData.projectType), props.projectState);
    props.history(`/${PROJECT_MANAGEMENT}?project-type=${resolvedType}`);
  }

  const ViewProject = () => {
    let { projectId } = state;
    props.history(`/${PROJECT_MANAGEMENT}/view/${projectId}`);
  }

  return (
    <>
      <DownloadDialog
        {...(state.downloadData || {})}
        handleDownloadDialog={handleDownloadDialog}
        downloadFile={downloadFile}
        templateOptions={state.templateOptions || []}
        downloadModuleName="Vendor Payment"
        dataCy="download-dialog"
      />
      {state.showPayInvoice && (
        <PayInvoice
          {...(state.invoiceData || {})}
          workType={state.workType}
          handleDownloadDialog={handleDownloadDialog}
          handleClose={() => handlePayInvoiceModal(false)}
          dataCy="pay-invoice-modal"
        />
      )}
      {state.showFilter && <DateFilter //date filter component
        startDate={state.startDate} //pass on date props to store date when filter is applied
        endDate={state.endDate}
        changeFilter={dateChangeFilter} //action when Apply Filter is clicked
        workType={state.workType}
        dialogClose={showFilterHandler}
        open={state.showFilter}
        dataCy="date-filter-dialog"
      />}

      {projectModule === false ? (
        <p>
          You do not currently have access to any Projects. Please
          contact your Administrator if this is required.
        </p>
      ) : (
        <>
          <div className="purchase-order-block" dataCy="contractors-invoices">
            <div className="row">
              <div className="w-auto">
                <h2 className="content-heading text-uppercase">Contractors Invoices</h2>
                <div className="col-12 breadcrumb-block p-0" dataCy="breadcrumb">
                  <Breadcrumb>
                    {state.breadCumbText && (
                      <>
                        <Breadcrumb.Item onClick={ViewProjectList} dataCy="breadcrumb-projects">PROJECTS</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={ViewProject} dataCy="breadcrumb-project">{idx(state, _ => _.projectData.name)}</Breadcrumb.Item>
                        <Breadcrumb.Item active dataCy="breadcrumb-contractors-invoices">Contractors Invoices</Breadcrumb.Item>
                      </>
                    )}
                  </Breadcrumb>
                </div>
              </div>
              {!state.projectId && (<div className="w-auto ms-auto mt-auto">
                {writePermission && (
                  <button
                    data-cy="contractor-receive-invoice"
                    className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary"
                    onClick={() => handlePayInvoiceModal(true, true)}
                  >
                    Receive Invoice
                  </button>)}
                <Tooltip title="Refresh Data">
                  <button
                    onClick={resetInvoiceData}
                    aria-label="filter"
                    className="btn"
                    data-cy="refresh-button"
                  >
                    <Autorenew />
                  </button>
                </Tooltip>
                <Tooltip title="Filters">
                  <button
                    onClick={showFilterHandler}
                    aria-label="filter"
                    className="btn"
                    data-cy="filter-button"
                  >
                    <FilterAltIcon />
                  </button>
                </Tooltip>
              </div>)}
            </div>

            <div className="row">
              <div className="col-12 mt-3" dataCy="contractors-invoices-table">

                <CustomTable
                  columns={state.columns}
                  data={state.subContractorsTable}
                  isAction={true}
                  handleMenu={(data) => handleMenu(data)}
                  menu={(data) => (
                    <Popover id="popover-basic" dataCy="contractors-invoices-table-menu">
                      <Popover.Body>
                        <ul className="action-block-list">
                          {writePermission && <li onClick={() => handlePayInvoiceModal(true)} dataCy="receive-invoice">
                            Receive Invoice
                          </li>}
                          <li onClick={() => viewPO()} dataCy="view-invoice">
                            View Invoice
                          </li>
                          {data.vendorType === "sub-contractor" && (<li onClick={() => handleDownloadDialog(data.invoiceId)} dataCy="download-payment-schedule">
                            Download Payment Schedule
                          </li>)}
                        </ul>
                      </Popover.Body>
                    </Popover>
                  )}
                  fileName='Sub-Contractors Invoices List'
                />

              </div>
            </div>
          </div>
        </>
      )}
    </>
  );

}

const mapStateToProps = (state) => ({
  projectModule: state.project.allowedModules,
  projectState: state.project,
});

const mapDispatchToProps = (dispatch) => ({
  getvendorsPOList: bindActionCreators(getvendorsPOList, dispatch),
  getGlobalSettingTemplateTypes: bindActionCreators(getGlobalSettingTemplateTypes, dispatch),
  downloadProjectPO: bindActionCreators(downloadProjectPO, dispatch),
  warningSnackBar: bindActionCreators(warningSnackBar, dispatch),
  getProject: bindActionCreators(getProject, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierInvoiceList));
